enum ActionTypes {
  FETCH_PRICE_BOOK_EXPORT_TYPES_REQUEST = 'PRICEBOOKS.FETCH_PRICE_BOOK_EXPORT_TYPES_REQUEST',
  FETCH_PRICE_BOOK_EXPORT_TYPES_SUCCESS = 'PRICEBOOKS.FETCH_PRICE_BOOK_EXPORT_TYPES_SUCCESS',
  FETCH_PRICE_BOOK_EXPORT_TYPES_FAILURE = 'PRICEBOOKS.FETCH_PRICE_BOOK_EXPORT_TYPES_FAILURE',
}

export default ActionTypes;
